import Count from "./count/count.store";

export default {
  modules: { Count },
};
